import { Badge } from '@iris/ui/components/ui/badge';
import { useTranslation } from 'react-i18next';

import { useShops } from './shop-context';

/**
 * The shop every screen is about, with its status when it is not active. One person works in one shop (ADR 0011
 * D1), so there is nothing to switch.
 */
export function ShopName() {
  const { t } = useTranslation();
  const { current } = useShops();
  if (!current) return null;
  return (
    <p className="flex min-w-0 items-center gap-2 text-sm font-medium">
      <bdi className="truncate">{current.displayName}</bdi>
      {current.status !== 'ACTIVE' ? (
        <Badge variant="secondary" className="shrink-0">
          {t(`shops.status.${current.status}`)}
        </Badge>
      ) : null}
    </p>
  );
}
